import {
  getUser as getUserApi,
  saveUserProfile as saveUserProfileApi,
  getUserOrganisations as getUserOrganisationsApi,
  updateUserOrganisation as updateUserOrganisationApi
} from '../../api/user';
import Vue from 'vue';
import { GLOBAL_ERROR } from '../../utils/constants';

export function getUser({ commit }) {
  return new Promise(async (resolve, reject) => {
    try {
      commit('setState', ['loadingUser', true]);
      const user = await getUserApi();
      commit('setUser', user);
      commit('setState', ['loadingUser', false]);
      return resolve(user);
    } catch (err) {
      commit('setState', ['loadingUser', false]);
      Vue.prototype.$euiNotifications.emit({
        notification: GLOBAL_ERROR
      });
      return reject();
    }
  });
}

export function saveUserProfile({ commit, state }, profile) {
  return new Promise(async (resolve, reject) => {
    try {
      commit('setState', ['savingUser', true]);
      const profilePayload = { ...profile };
      delete profilePayload.matchesOrganisations;
      delete profilePayload.corporateEmailVerified;
      delete profilePayload.firstName;
      delete profilePayload.lastName;
      const response = await saveUserProfileApi(profilePayload);
      // if company email requires verification, pop up notification for email sent
      if (response.validateEmailUrl) {
        Vue.prototype.SAIDialog({
          body: `Your work email requires verification.
          An email has been sent to your company email, please verify your email to complete the profile.`,
          okText: 'Ok'
        });
      }
      delete response.validateEmailUrl;
      commit('setUser', { 
        ...state.user, 
        profile: response, 
        contactDetails: {
          ...state.user.contactDetails,
          addressLineOne: response.addressLineOne,
          addressLineTwo: response.addressLineTwo,
          unitNumber: response.unitNumber,
          workPhone: response.workPhone
        }
      });
      commit('setState', ['savingUser', false]);
      return resolve(response);
    } catch (err) {
      commit('setState', ['savingUser', false]);
      Vue.prototype.$euiNotifications.emit({
        notification: GLOBAL_ERROR
      });
      return reject();
    }
  });
}

export function getUserOrganisations({ commit }) {
  return new Promise(async (resolve, reject) => {
    try {
      commit('setState', ['loadingUserOrganisations', true]);
      const response = await getUserOrganisationsApi();
      commit('setUserOrganisations', response.organisations || []);
      commit('setState', ['loadingUserOrganisations', false]);
      return resolve();
    } catch (err) {
      commit('setState', ['loadingUserOrganisations', false]);
      Vue.prototype.$euiNotifications.emit({
        notification: GLOBAL_ERROR
      });
      return reject();
    }
  });
}

export function updateUserOrganisation({ commit, state }, orgId) {
  return new Promise(async (resolve, reject) => {
    try {
      commit('setState', ['savingUserOrganisation', true]);
      await updateUserOrganisationApi(orgId);
      const updatedUser = {
        ...state.user,
        hasOrganisation: true
      };
      commit('setUser', updatedUser);
      commit('setState', ['savingUserOrganisation', false]);
      return resolve();
    } catch (err) {
      commit('setState', ['savingUserOrganisation', false]);
      Vue.prototype.$euiNotifications.emit({
        notification: GLOBAL_ERROR
      });
      return reject();
    }
  });
}
